import React from 'react';
// components
import { Alert } from 'styled-alert-component';

const DispatchErrorBody = ({ errors, handleClose }) => {
  return (
    <div className='modal-body'>
      <Alert error>
        <h4>The following PRO’s cannot be dispatched</h4>
        <ul>
          {errors.map(item => (
            <li key={item.proNumber}>{item.proNumber} - {item.reason}</li>
          ))}
        </ul>
      </Alert>
      <div className='toolbar toolbar--xxs'>
        <div className='toolbar--column toolbar--right'>
          <button id='cancel-finalize' className='button large white text-align--center margin--none--xxs' onClick={handleClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DispatchErrorBody;
